"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNetwork = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("./utils");

var getConnection = function getConnection() {
  return utils_1.isBrowser ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
};

var getConnectionState = function getConnectionState() {
  var connectionState = {};
  var connection = getConnection();

  if (connection !== null) {
    var downlink = connection.downlink,
        downlinkMax = connection.downlinkMax,
        effectiveType = connection.effectiveType,
        type = connection.type,
        rtt = connection.rtt;
    connectionState = {
      downlink: downlink,
      downlinkMax: downlinkMax,
      effectiveType: effectiveType,
      type: type,
      rtt: rtt
    };
  }

  return connectionState;
};

function useNetwork(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _a = React.useState(initialState),
      state = _a[0],
      setState = _a[1];

  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var localState_1 = state;

      var localSetState_1 = function localSetState_1(patch) {
        localState_1 = __assign(__assign({}, state), patch);
        setState(localState_1);
      };

      var connection_1 = getConnection();

      var onOnline_1 = function onOnline_1() {
        localSetState_1({
          online: true,
          since: new Date()
        });
      };

      var onOffline_1 = function onOffline_1() {
        localSetState_1({
          online: false,
          since: new Date()
        });
      };

      var onConnectionChange_1 = function onConnectionChange_1() {
        localSetState_1(getConnectionState());
      };

      utils_2.on(window, 'online', onOnline_1);
      utils_2.on(window, 'offline', onOffline_1);

      if (connection_1 !== null) {
        utils_2.on(connection_1, 'change', onConnectionChange_1);
        localSetState_1(__assign(__assign(__assign({}, state), {
          online: navigator.onLine,
          since: undefined
        }), getConnectionState()));
      }

      return function cleanup() {
        utils_2.off(window, 'online', onOnline_1);
        utils_2.off(window, 'offline', onOffline_1);

        if (connection_1 !== null) {
          utils_2.off(connection_1, 'change', onConnectionChange_1);
        }
      };
    }
  }, []);
  return state;
}

exports.useNetwork = useNetwork;